import { IAgentSchema } from '@cian/api-models/offer-card/v1/get-offer-data';

export const createAgentIdName = ({ isSubAgent, id, parentCianId }: IAgentSchema) => {
  const isMasterAgentIdExist = typeof parentCianId !== 'undefined' && parentCianId !== null;

  const agentId = isSubAgent && isMasterAgentIdExist ? parentCianId : id;

  return `ID ${agentId}`;
};
